import { render, staticRenderFns } from "./MultiLanguageInput.vue?vue&type=template&id=5c48d9c8"
import script from "./MultiLanguageInput.vue?vue&type=script&lang=js"
export * from "./MultiLanguageInput.vue?vue&type=script&lang=js"
import style0 from "./MultiLanguageInput.vue?vue&type=style&index=0&id=5c48d9c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports